import { getSelectedProduct, selectProduct } from 'axp-product-ducks';
import { getProcedureResult } from 'iguazu-rpc';
import getAccountNumberFromPath from './getAccountNumberFromPath';
import { READ_CUSTOMER_PRODUCTS_V2_FUNCTION, ROUTES } from '../constants';
import {
  getDefaultProduct,
  isProductBusinessBanking,
} from './getDefaultProduct';

const onEnterSetSelectedProduct =
  (store) => async (nextState, replace, callback) => {
    const productsResult = getProcedureResult({
      procedureName: READ_CUSTOMER_PRODUCTS_V2_FUNCTION,
      args: {
        timeout: 6e3,
      },
    })(store.getState());

    const selectedProduct = await getSelectedProduct(store.getState());
    const newSelectedProduct = getAccountNumberFromPath(
      nextState.location.pathname
    );

    const isSelectedProductBusinessBanking = isProductBusinessBanking(
      productsResult,
      selectedProduct
    );
    const isNewSelectedProductBusinessBanking = isProductBusinessBanking(
      productsResult,
      newSelectedProduct
    );

    let productToSelect;
    if (!isSelectedProductBusinessBanking) {
      productToSelect = isNewSelectedProductBusinessBanking
        ? newSelectedProduct
        : getDefaultProduct(productsResult).opaqueAccountId;
    } else if (
      newSelectedProduct !== null &&
      newSelectedProduct !== selectedProduct
    ) {
      productToSelect = isNewSelectedProductBusinessBanking
        ? newSelectedProduct
        : undefined;
    } else {
      return callback();
    }

    if (productToSelect) {
      await store.dispatch(selectProduct(productToSelect));
    } else {
      replace(
        ROUTES.ACCOUNTS_DETAILS.replace(
          ':id',
          encodeURIComponent(selectedProduct)
        )
      );
    }
    return callback();
  };

export default onEnterSetSelectedProduct;
